import React, { useEffect, useState } from 'react';
import './DevTube.css'; 
import axios from 'axios';
import videoJob from './DEVTUBE-VIDEO.mov';

const carouselItems = [
  { type: 'video', src: videoJob, alt: 'DevTube Demo' },
  // { type: 'image', src: yourImage, alt: 'Some Image' }, // You can add more
];

const HeroCarousel = () => {
  // For multiple items, you can add auto-slide logic here if you want
  return (
    <div className="hero-carousel">
      {carouselItems.map((item, idx) =>
        item.type === 'video' ? (
          <video
            className="carousel-media"
            key={idx}
            src={item.src}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          />
        ) : (
          <img
            className="carousel-media"
            key={idx}
            src={item.src}
            alt={item.alt}
          />
        )
      )}

    </div>
  );
};

const extractVideoId = (url) => {
  const videoIdRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/;
  const match = url.match(videoIdRegex);
  return match ? match[1] : null;
};

const DevTube = () => {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);
  const [visibleCourses, setVisibleCourses] = useState(6);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get('http://localhost:4000/api/courses');
        setCourses(response.data.courses || []);
      } catch (error) {
        setError(error);
      }
    };

    fetchCourses();
  }, []);

  const showMoreCourses = () => {
    setVisibleCourses(visibleCourses + 3);
  };

  const isYouTubeLink = (url) => {
    return url && (url.includes('youtube.com') || url.includes('youtu.be'));
  };

  if (error) {
    return <div style={{ color: "#ef4444", textAlign: "center", padding: "20px" }}>Error: {error.message}</div>;
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  return (
    <div>
      <HeroCarousel />
      <div className='courseboard'>
        <div className='courseboard-title'>CourseBoard</div>
        <div className='courseboard-container-title'>Recent Courses</div>
        <div className='courseboard-container'>
          {courses.slice(0, visibleCourses).map((course, index) => (
            <div key={course.id} className='courseboard-box'>
              <div className='coursetitle'>{course.title}</div>
              <div className='coursesubtitle'>{course.subtitle}</div>
              <div className='coursedescription'>{course.description}</div>
              <div className='coursesubmissionDate'>{formatDate(course.submission_date)}</div>
              <div className='course-keylang'>{(course.keylang || []).join(', ')}</div>
              {isYouTubeLink(course.URL) ? (
                <iframe
                  src={`https://www.youtube.com/embed/${extractVideoId(course.URL)}`}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <div className='warning-message'>This is not a YouTube link.</div>
              )}
            </div>
          ))}
          {visibleCourses < courses.length && (
            <button className='course-showmore' onClick={showMoreCourses}>Show More</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DevTube;
